import { render, staticRenderFns } from "./AutoAssessmentList.vue?vue&type=template&id=5bbd6a40"
import script from "./AutoAssessmentList.vue?vue&type=script&lang=js"
export * from "./AutoAssessmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports